export default __webpack_public_path__ + "static/media/ic_selector_dropdowns.bb80627c.svg";